module.exports = __webpack_public_path__ + "static/media/seasonal_page_Q4_2025_playground_btn.fabaf72a.png";